import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import Building from "../images/Building1.png";

const ChangeLocationPopup = ({
  deliveryAddresses = [],
  deliveryAddress,
  setDeliveryAddress,
  setShowLocationPopup,
  StatePerameters,
  UpdateAdressToQuote
}) => {
  const navigate = useNavigate();
  const [selectedAddress, setSelectedAddress] = useState(deliveryAddress || null);
  const [loading, setLoading] = useState(false); // new loading state
  const location = useLocation()

  const handleSelectedAddress = async (newSelectedAddress) => {
    try {
      if (!newSelectedAddress?._id) return;

      setLoading(true); // start loading

      const token = sessionStorage.getItem('token');
      const url = process.env.REACT_APP_FORE_BRICKBUCKET;

      const response = await fetch(`${url}customer/delivery-address/update-delivery-address-latest-used`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify({
          delivery_address_id: newSelectedAddress._id,
          customer_id: newSelectedAddress.customer_id,
        }),
      });

      const data = await response.json();

      if (data.success) {
        if(location.pathname === '/consumer/app/orderdetails' && StatePerameters.quotationId){
        await UpdateAdressToQuote(StatePerameters.quotationId, newSelectedAddress._id)
        }
        setDeliveryAddress(data.data || newSelectedAddress);
        console.log('Delivery Address Set:', data.data);
      } else {
        console.error('Failed to update delivery address:', data.message);
      }
    } catch (error) {
      console.error('Error updating delivery address:', error);
    } finally {
      setLoading(false); // stop loading
      setShowLocationPopup(false);
    }
  };



  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"></div>

      {/* Popup */}
      <div className="fixed bottom-0 left-0 right-0 bg-[#F5F5F5] rounded-t-2xl z-50 h-[85vh] flex flex-col">
        {/* Header */}
        <div className="px-5 py-4 flex items-center justify-between border-b border-gray-200 bg-[#F5F5F5] sticky top-0 z-10">
          <h3 className="text-md font-bold text-[#524D4D] mt-1">Delivery Location</h3>
          <button
            onClick={() => setShowLocationPopup(false)}
            className="bg-gray-200 text-gray-600 w-8 h-8 rounded-full flex items-center justify-center hover:bg-gray-300 transition-colors"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Add New Address (Top) */}
        <div className="px-5 py-3 border-b border-gray-200 bg-white">
          <button
            className="w-full flex items-center justify-between py-3 px-4 rounded-lg bg-white border border-gray-200 shadow-sm hover:bg-gray-50 transition"
            onClick={() => {
              setShowLocationPopup(false);
              navigate("/consumer/addaddress", {
                state: {
                  from: location.pathname, // Dynamically set to the current URL pathname
                  StatePerameters:StatePerameters
                },
              });
            }}
          >
            <div className="flex items-center gap-3">
              <svg
                className="w-6 h-6 text-[#448B32]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v12m6-6H6" />
              </svg>
              <span className="text-[#448B32] text-md font-bold">Add New Address</span>
            </div>

            <svg
              className="w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Scrollable Address List */}
        <div className="flex-1 overflow-y-auto px-5">
          {deliveryAddresses.length > 0 && (
            <p className="text-xs font-medium text-[#666666] mt-3 mb-3 uppercase tracking-wide">
              Select your delivery address
            </p>
          )}

          {deliveryAddresses.length > 0 ? (
            <div className="mb-6 space-y-3">
              {deliveryAddresses.map((address, index) => (
                <div
                  key={address._id || index}
                  className={`flex items-start p-4 rounded-lg border cursor-pointer transition 
                  ${
                    selectedAddress?._id === address?._id
                      ? "border-red-400 bg-red-50"
                      : "border-gray-200 bg-white hover:border-gray-300"
                  }`}
                  onClick={() => setSelectedAddress(address)}
                >
                  {/* Icon */}
                  <div className="flex-shrink-0 mr-3">
                    <div className="bg-[#F5F5F5] rounded-md w-12 h-12 flex items-center justify-center">
                      {address?.address_type === "project" ? (
                        <>
                        <img src={Building} alt="Building" className="h-7 w-7 object-contain" />
                        </>
                      ) : (
                        <svg
                          className="w-7 h-7 text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                      )}
                    </div>
                  </div>

                  {/* Address Info */}
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-[#170101]">
                      {address?.address_type === "project"
                        ? (address?.project_name?.toUpperCase() || 'Project Address')
                        : "Other Address"}
                    </p>
                    <p className="text-xs text-[#444] mt-1">
                      {address?.area_sector_locality || "No details available"}
                    </p>
                    {address?.nearby_landmark && address?.nearby_landmark !== address?.project_name && (
                      <p className="text-xs text-gray-500 mt-1">Near {address?.nearby_landmark}</p>
                    )}
                  </div>

                  {/* Radio */}
                  <div className="flex-shrink-0 ml-3">
                    <div
                      className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                        selectedAddress?._id === address?._id ? "border-red-500" : "border-gray-300"
                      }`}
                    >
                      {selectedAddress?._id === address?._id && (
                        <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="py-12 text-center text-gray-500 text-sm flex flex-col items-center">
              <div className="w-16 h-16 mb-4 flex items-center justify-center rounded-full bg-gray-100">
                <svg
                  className="w-8 h-8 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v12m6-6H6" />
                </svg>
              </div>
              <p className="text-base font-semibold text-gray-700 mb-1">No saved addresses</p>
              <p className="text-sm text-gray-500">Add a new address to continue with your order.</p>
            </div>
          )}
        </div>

        {/* Apply Button - only shows when an address is selected */}
        {selectedAddress && (
          <div className="px-3 py-3 border-t border-gray-200 bg-white sticky bottom-0 z-20">
            <button
              className={`w-full py-3 px-4 rounded-lg bg-red-500 text-white font-semibold shadow-md transition
              ${loading ? 'opacity-60 cursor-not-allowed' : 'hover:bg-red-600'}`}
              onClick={() => handleSelectedAddress(selectedAddress)}
              disabled={loading} // disable while loading
            >
              {loading ? 'Applying...' : 'Apply Selected Address'}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ChangeLocationPopup;
